import { t } from 'i18next';

import Input from '#components/general/Input';
import { getSubStepValues } from '#models/general/steps';
import FileInput from '#components/general/FileInput';
import { ACCEPT_ONLY_IMAGES } from '#constants/files';
import Button from '#components/general/Button';
import TrashImage from '#assets/delete.svg';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';

import { CUSTOM_SECTION_FIELDS, NEW_PRODUCT_SUBSTEPS_IDS } from './constants';
import styles from './styles.module.scss';

const newSubstep = (removeSubstep, id) => (getCustomSubstepValues, getCurrentCustomSubsteps, values) =>
  [
    {
      key: `substep-${id}`,
      Component: AdelphiFieldsRow,
      secondGrow: true,
      fields: [
        {
          key: `removeSubstep-${id}`,
          Component: Button,
          children: <img src={TrashImage} className={styles.deleteAlt} />,
          onClick: () => removeSubstep(getCurrentCustomSubsteps)
        },
        {
          ...getCustomSubstepValues(`${CUSTOM_SECTION_FIELDS.TITLE}-${id}`),
          Component: Input,
          placeholder: t(`${NEW_PRODUCT_SUBSTEPS_IDS.CUSTOM_SECTION}:${CUSTOM_SECTION_FIELDS.TITLE}`),
          registerParams: { required: true }
        }
      ]
    },
    {
      ...getCustomSubstepValues(`${CUSTOM_SECTION_FIELDS.DESCRIPTION}-${id}`),
      Component: Input,
      placeholder: t(`${NEW_PRODUCT_SUBSTEPS_IDS.CUSTOM_SECTION}:${CUSTOM_SECTION_FIELDS.DESCRIPTION}`),
      registerParams: { required: true }
    },
    {
      ...getCustomSubstepValues(`${CUSTOM_SECTION_FIELDS.IMAGE}-${id}`),
      Component: FileInput,
      placeholder: t(`${NEW_PRODUCT_SUBSTEPS_IDS.CUSTOM_SECTION}:${CUSTOM_SECTION_FIELDS.IMAGE}`),
      accept: ACCEPT_ONLY_IMAGES,
      noMargin: true,
      srcUrl: values[`${CUSTOM_SECTION_FIELDS.IMAGE}-${id}`],
      fileType: 'image'
    },
    {
      ...getCustomSubstepValues(`${CUSTOM_SECTION_FIELDS.VIDEO}-${id}`),
      Component: Input,
      placeholder: t(`${NEW_PRODUCT_SUBSTEPS_IDS.CUSTOM_SECTION}:${CUSTOM_SECTION_FIELDS.VIDEO}`)
    }
  ];

const mapInitialCustomSubstep = id => ({
  component: removeSubstep => newSubstep(removeSubstep(id), id),
  id
});

export const mapInitialCustomSubsteps = ids => ids?.map(id => mapInitialCustomSubstep(id));

export const getCustomSubstepFields = ({ values, errors, setSubStepState, subStepState }) => {
  const getCustomSubstepValues = getSubStepValues(NEW_PRODUCT_SUBSTEPS_IDS.CUSTOM_SECTION, values, errors);

  const getCurrentCustomSubsteps = () => (subStepState?.customSubsteps ? subStepState.customSubsteps : []);

  const addSubstep = () => {
    const lastId = getCurrentCustomSubsteps()
      .map(({ id }) => id)
      .findLast(() => true);
    const newId = lastId >= 0 ? lastId + 1 : 0;
    setSubStepState({
      ...subStepState,
      customSubsteps: [
        ...getCurrentCustomSubsteps(),
        {
          component: removeSubstep => newSubstep(removeSubstep(newId), newId),
          id: newId
        }
      ]
    });
  };

  const removeSubstep = id => () => {
    setSubStepState({
      ...subStepState,
      customSubsteps: getCurrentCustomSubsteps().filter(({ id: thisId }) => thisId !== id)
    });
  };

  return [
    ...getCurrentCustomSubsteps()?.flatMap(({ component }) =>
      component(removeSubstep)(getCustomSubstepValues, getCurrentCustomSubsteps, values)
    ),
    {
      key: 'addSubstep',
      Component: Button,
      children: t(`${NEW_PRODUCT_SUBSTEPS_IDS.CUSTOM_SECTION}:${CUSTOM_SECTION_FIELDS.NEW_CUSTOM_SECTION}`),
      onClick: addSubstep,
      secondary: true
    }
  ];
};
